/**
 * Content mirrored from privatestaysapp.com.
 * Kept in one place so every section reads from a single source of truth.
 */

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Testimonials", href: "#testimonials" },
];

export const LOGIN_URL = "https://privatestays.geeksae.com/";
export const DOWNLOAD_URL = "https://onelink.to/y5d4pq";

export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/privatestaysapp/" },
  { label: "Youtube", href: "https://www.youtube.com/@PrivateStays" },
];

export const FEATURES = [
  {
    id: "gems",
    icon: "jordan",
    title: "Explore Jordan's Hidden Gems",
    body: "From cozy farmhouses to adventurous camps, discover unique accommodations across the country.",
  },
  {
    id: "tailored",
    icon: "tent",
    title: "Tailored Experiences",
    body: "Our platform helps you find the perfect stay to match your preferences and travel goals.",
  },
  {
    id: "booking",
    icon: "booking",
    title: "Easy Booking",
    body: "Our user-friendly app ensures hassle-free bookings for your dream stay.",
  },
];

export const SERVICES = [
  { id: "secure", icon: "secure", title: "Secure Reservation" },
  { id: "reviews", icon: "reviews", title: "In-App Reviews" },
  { id: "support", icon: "support", title: "Customer Support" },
];

/**
 * The surrounding double quotes are part of the reference's copy — it renders
 * them as literal characters inside each card, not as a decorative glyph. Keep
 * them in the string so the rendered text matches the original exactly.
 */
export const TESTIMONIALS = [
  {
    id: "sarah",
    name: "Sarah W.",
    role: "Customers",
    quote:
      '"Private Stays made my Jordanian adventure incredible. The farmhouse I booked was a hidden gem."',
  },
  {
    id: "ahmed",
    name: "Ahmed A.",
    role: "Customers",
    quote: '"The Private Stays app is user-friendly, and their customer support is top-notch."',
  },
  {
    id: "lina",
    name: "Lina H.",
    role: "Customers",
    quote: '"I\'ll never forget my camping experience in Jordan, thanks to Private Stays."',
  },
  {
    id: "karim",
    name: "Karim T.",
    role: "Customers",
    quote:
      '"The local insights provided by Private Stays hosts added a unique touch to my trip."',
  },
];

export const PLAN_FEATURES = [
  "Access all pro features",
  "Graphs and statistics",
  "Remote server selection",
  "Ad-free experience",
  "24/7 Support Service",
];

export const PLANS = [
  { id: "basic", name: "Basic Plan", price: "$15", period: "/mth", featured: false },
  { id: "business", name: "Business plan", price: "$20", period: "/mth", featured: true },
  { id: "enterprise", name: "Enterprise plan", price: "$25", period: "/mth", featured: false },
];

export const ADDRESS = {
  lines: ["Jl. Niti Mandala Renon No.88,", "Denpasar, Bali - 80239"],
  phone: "(+021) 212 345",
};

/**
 * Matches the reference footer exactly: "Terms of use" is plain text there
 * (a <span>, not an <a> — and /terms-of-use/ 404s), while "Privacy policy"
 * links to a real published page. Items without `href` render as text.
 */
export const LEGAL_LINKS = [
  { label: "Terms of use" },
  { label: "Privacy policy", href: "https://privatestaysapp.com/privacy-policy/" },
];
